export default "__VITE_ASSET__DLyQWIa2__"